import { Button, Paper, Typography } from "@mui/material";
import React, {useEffect, useState} from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
    Animated,
    View,
    Text,
    TextInput,
    Platform,
    Dimensions
    
  } from 'react-native';
import Preview from "./Preview";

 
 
interface IFormInput {
  messageValue: string;
  recipientsValue: string;
  choicesValue: string;
  workflowValue: string;
  priorityValue: string;
  soundtypeValue: string;
 
}

    
  const PayloadEditor=(props:any)=>{
    const [data, setData]=useState(props.data);
    const [message,setMessage]= useState("");
    const [recipients, setRecipients]=useState("");
    const [emails, setEmails]=useState("");
    const [messageType, setMessageType]=useState("");
    const [choices,setChoices]=useState("");
    const [workflow,setWorkflow]=useState("");
    const [responselpp, setResponselpp]=useState("");
    const [priority, setPriority]=useState("");
    const [soundType,setSoundType]=useState("");
    const [messData,setMessData]=useState([]);
    const [dim, setDim] = useState([
      Dimensions.get('window').width,
      Dimensions.get('window').height,
      Dimensions.get('window').width > Dimensions.get('window').height,
    ]);
  let onLayout = (e: any) => {
      setDim([e.nativeEvent.layout.width, e.nativeEvent.layout.height]);
    };
    const isDesktop = dim[0] > 1224;
    const isSmall = dim[0] < 700;
    const defaultValues = {
      messageValue: message,
      recipientsValue: recipients,
      choicesValue: choices,
      workflowValue: workflow,
      priorityValue: priority,
      soundtypeValue: soundType,
    };

    useEffect(()=>{
       //console.log("data:",JSON.stringify(data));
       setData(props.data);
       if(data && props.isEpic === true ||data && props.isTemplate === true){
        setMessageType(props.data.message_type);
        setRecipients(props.data.recipients);
        setMessage(props.data.message);
        setChoices(props.data.choices);
        setWorkflow(props.data.workflow);
        setPriority(props.data.priority);
        setSoundType(props.data.sound_type);
        var msg:any = props.data.message;
       // console.log(msg);
        var nMsg:any;
        if(msg !==undefined){
          if(msg.indexOf("&#xa;")>-1){
            nMsg= msg.split("&#xa;");
            setMessData(nMsg);
          }
          else if(msg.indexOf("\n")>-1){
            nMsg= msg.split("\n");
            setMessData(nMsg);
          }
         
        }
        
       }
      
      
    },[props.data,props.isTemplate, props.isEpic]);

    const handleSubmit = () => {
       var newdata:any={};
       newdata.message_type= messageType;
       newdata.message = message;
       newdata.recipients= recipients;
       newdata.emails = "";
       newdata.choices=choices;
       newdata.workflow=workflow;
       newdata.responselpp=props.data.responselpp;
       newdata.priority=priority;
       newdata.sound_type=soundType;
       
       //console.log("newdata:", JSON.stringify(newdata));
       if(newdata.message_type ==="" ||newdata.message ==="" || newdata.recipients==="" || newdata.choices ==="" || newdata.priority ==="" ||  newdata.sound_type===""){
        //toast("No allowed empty or blank one of the field.");
        toast.error('🦄 No allowed empty or blank one of the field!', {
          position: "bottom-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          });
       }
       else{

        /*var sendedData:any ={};
        sendedData.message_type= messageType;
        sendedData.message = messData;
        sendedData.recipients= recipients;
        sendedData.workflow=workflow;
        var ntemp =messageType.replace(/\s+/g, '');
        var newType = ntemp.toLowerCase();
        AppendToLocalStorageV(newType,JSON.stringify(sendedData));
        props.setIsSubmit(true);
        props.setValueTabs(1);*/
         
       
       fetch('https://ip-test.teleport.umms.org/sendtiger', {
          method: 'POST',
          body: JSON.stringify(newdata),
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(res => res.json())
        .then(data =>{
         console.log("data..."+data.status); 
         if(data.status === "OK"){
          var sendedData:any ={};
          sendedData.message_type= messageType;
          sendedData.message = messData;
          sendedData.recipients= recipients;
          sendedData.workflow=workflow;
          var ntemp =messageType.replace(/\s+/g, '');
          var newType = ntemp.toLowerCase();
          AppendToLocalStorageV(newType,JSON.stringify(sendedData));
          toast.success('Your Code blue has been sent!', {
           position: "bottom-center",
           autoClose: 3000,
           hideProgressBar: false,
           closeOnClick: true,
           pauseOnHover: true,
           draggable: true,
           progress: undefined,
           theme: "colored",
           });
           props.setIsSubmit(true);
           setTimeout(()=>{ props.setValueTabs(1);},4000);

         }
         else{
          toast.error('🦄 There is an error sending Code Blue '+ data.status, {
            position: "bottom-center",
            autoClose: 6000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            });
         }
 
        
        
         


        }).catch(error =>{
          
          
          //toast("There is an error sending Code Blue: "+error);
          toast.error('🦄 There is an error sending Code Blue ' + error, {
            position: "bottom-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            });
        });

       }

      

    };
    const reset=()=>{
      setRecipients("");
      setMessage("");
      setChoices("");
      setWorkflow("");
      setPriority("");
      setSoundType("");
      setMessageType("");
      setEmails("");
      props.setIsEpic(false);
      props.setIsTemplate(false);
    };

    const changeMessage=(e:any)=>{
      setMessage(e);
      var msg:any = e;
      if(msg.indexOf("&#xa;")>-1){
        var nMsg:any= msg.split("&#xa;");
        setMessData(nMsg);
      }
     
    };
 
   

  function AppendToLocalStorageV(name:any, value:any) {
    let n = 0;
    while (localStorage.getItem(name + n)) {
        n++;
    }
    localStorage.setItem(name + n, value); //add item at first available index number
}
  

    return(
      <View style={{width:'100%', borderWidth:1, borderRadius:5,padding:10 }}>
         <ToastContainer />
          <View style={{height:40, backgroundColor:'#92c0f5', justifyContent:'center'}}><Typography>Payload Editor</Typography></View>
          <View style={{flexDirection:Platform.OS === 'web' && isDesktop ? 'row':'column', justifyContent:'space-around'}}>
            <View style={{ width:'50%', borderRadius:5, padding:10, justifyContent:'flex-start'}}>
              <Text>Message: </Text>
                            <TextInput multiline
                      numberOfLines={4}
                      style={{borderWidth:3,height:200, maxHeight:500, padding:10}}
                      maxLength={5000} onChangeText={e => changeMessage(e)} value={message}/>
                 <View style={{marginTop:15, flexDirection:'row', justifyContent:'space-evenly'}}>
              <Text>{`&#xa; is equal to a new line in Tiger Connect message`}</Text>
              <Preview data={messData} messageType={messageType}  />
             </View>
            </View>
            <View style={{ width:'50%', padding:10, paddingLeft:20,}}>
              <View style={{ width:'100%'}}>
              <Text>Recipients: </Text>
                          <TextInput multiline
                    numberOfLines={2}
                    style={{borderWidth:1, maxHeight:200,padding:3}}
                    maxLength={500} onChangeText={value=> setRecipients(value)} value={recipients}/>
                 </View>
             
              <View style={{flexDirection:Platform.OS === 'web' && isDesktop ? 'row':'column', marginTop:10, }}>
                <View style={{ width:'40%'}}>  
                  <Text>Message Type: </Text>
                              <TextInput multiline
                    numberOfLines={2}
                    style={{borderWidth:1,maxHeight:200,padding:3}}
                    maxLength={200} onChangeText={value=> setMessageType(value)} value={messageType}/>
                                </View>
                <View style={{marginLeft:24,width:'40%'}}>  
                  <Text>Email: </Text>
                                <TextInput multiline
                      numberOfLines={2}
                      style={{borderWidth:1,maxHeight:200,padding:3}}
                      maxLength={200} onChangeText={value=> setEmails(value)} value={emails}/>
 
                </View>
            
              </View>
              <View style={{flexDirection:Platform.OS === 'web' && isDesktop ? 'row':'column', marginTop:10,width:'100%', justifyContent:'flex-start' }}>
                <View style={{width:'40%'}}>  
                  <Text>Choices: </Text>
                          <TextInput multiline
                numberOfLines={2}
                style={{borderWidth:1, maxHeight:200,padding:3}}
                maxLength={200} onChangeText={value=> setChoices(value)} value={choices}/>
                </View>
                <View style={{marginLeft:24,width:'40%'}}>  
                  <Text>Workflow: </Text>
                          <TextInput multiline
                numberOfLines={2}
                style={{borderWidth:1, maxHeight:200, width:'100%', maxWidth:400,padding:3}}
                maxLength={500} onChangeText={value=> setWorkflow(value)} value={workflow}/>
                    </View>
          
              </View>
              <View style={{flexDirection:Platform.OS === 'web' && isDesktop ? 'row':'column', marginTop:10}}>
                <View style={{width:'40%'}}>  
                  <Text>Priority: </Text>
                  <TextInput multiline
                numberOfLines={2}
                style={{borderWidth:1, maxHeight:200, width:'100%', maxWidth:400,padding:3}}
                maxLength={500} onChangeText={value=> setPriority(value)} value={priority}/>
                 </View>

                <View style={{marginLeft:24,width:'40%'}}>  
                  <Text>Sound Type: </Text>
                  <TextInput multiline
                numberOfLines={2}
                style={{borderWidth:1, maxHeight:200, width:'100%', maxWidth:400,padding:3}}
                maxLength={500} onChangeText={value=> setSoundType(value)} value={soundType}/>
                   </View>
            
              </View>
                
                <View style={{flexDirection:'row', justifyContent:'center', marginTop:30}}>
                <Button style={{marginRight:40}} onClick={handleSubmit} variant={"contained"}>Send New Code Blue</Button>
                <Button onClick={() => reset()} variant={"outlined"}>
                                Reset Payload
                            </Button>
                </View>
           
            </View>
          </View>
      </View>
    );

  }
 // export default forwardRef(PayloadEditor);  
 export default PayloadEditor;